module.exports = __webpack_public_path__ + "static/media/mbWayLogo.2ff10867.png";